import { CancellationPolicyEntity } from "../domain/cancellationPolicy.entity";

export interface CancellationPolicyDTO {
  ticker: string;
  // TODO: add properties as needed
}

export function dtoToEntity(dto: CancellationPolicyDTO[]): CancellationPolicyEntity[] {
  if (!dto.length) {
    return [];
  }
  return dto.map(it => ({
    ticker: it.ticker,
  }));
}
